export default __webpack_public_path__ + "static/media/cassette-player.a7de9170.png";